module.exports = __webpack_public_path__ + "static/media/loyalty-card.15384f20.png";